// extracted by mini-css-extract-plugin
export var menuItem = "z_vg d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "z_vh d_Z d_bz d_bP";
export var menuMainLink = "z_vj d_f0 d_dB";
export var menuLink = "z_vk d_f0 d_dB";
export var icon = "z_p9 d_bC d_bP";
export var divider = "z_vl d_bC d_bP";
export var sublinks = "z_vm";
export var link = "z_mC";
export var Link = "z_s2 x_s2 x_sf x_sz";